/* eslint-disable no-shadow */
import { Action } from '@ngrx/store';
import { NewProjectModelRelation, ProjectModelRelation, ProjectModelRelationUpdateDto, OpenAiDataModelRelationResponseDto, GenerateDataModelRelationsFromExampleDataDto } from '@rappider/rappider-sdk';

export enum ActionTypes {
  GetAllProjectModelRelations = '[ProjectModelRelation] GetAllProjectModelRelations',
  GetAllProjectModelRelationsSuccessful = '[ProjectModelRelation] GetAllProjectModelRelationsSuccessful',
  GetProjectModelRelations = '[ProjectModelRelation] GetProjectModelRelations',
  GetProjectModelRelationsSuccessful = '[ProjectModelRelation] GetProjectModelRelationsSuccessful',
  GetProjectModelRelationsFailure = '[ProjectModelRelation] GetProjectModelRelationsFailure',
  CreateProjectModelRelation = '[ProjectModelRelation] CreateProjectModelRelation',
  CreateProjectModelRelationSuccessful = '[ProjectModelRelation] CreateProjectModelRelationSuccessful',
  CreateProjectModelRelationFailure = '[ProjectModelRelation] CreateProjectModelRelationFailure',
  UpdateProjectModelRelation = '[ProjectModelRelation] UpdateProjectModelRelation',
  UpdateProjectModelRelationSuccessful = '[ProjectModelRelation] UpdateProjectModelRelationSuccessful',
  UpdateProjectModelRelationFailure = '[ProjectModelRelation] UpdateProjectModelRelationFailure',
  DeleteProjectModelRelation = '[ProjectModelRelation] DeleteProjectModelRelation',
  DeleteProjectModelRelationSuccessful = '[Project Model] DeleteProjectModelRelationSuccessful',
  DeleteProjectModelRelationFailure = '[Project Model] DeleteProjectModelRelationFailure',
  GenerateDataModelsWithRelations = '[ProjectModelRelation] GenerateDataModelsWithRelations',
  GenerateDataModelsWithRelationsSuccessful = '[ProjectModelRelation] GenerateDataModelsWithRelationsSuccessful',
  GenerateDataModelsWithRelationsFailure = '[ProjectModelRelation] GenerateDataModelsWithRelationsFailure',
  /* AI Relations Generation (New) */
  GenerateProjectModelRelationsWithAI = '[ProjectModelRelation] GenerateProjectModelRelationsWithAI',
  GenerateProjectModelRelationsWithAISuccessful = '[ProjectModelRelation] GenerateProjectModelRelationsWithAISuccessful',
  GenerateProjectModelRelationsWithAIFailure = '[ProjectModelRelation] GenerateProjectModelRelationsWithAIFailure',
  ErrorAction = '[ProjectModelRelation] ErrorAction'
}

export class GetAllProjectModelRelations implements Action {
  readonly type = ActionTypes.GetAllProjectModelRelations;
  constructor() { }
}

export class GetAllProjectModelRelationsSuccessful implements Action {
  readonly type = ActionTypes.GetAllProjectModelRelationsSuccessful;
  constructor(public payload: { projectModelRelations: ProjectModelRelation[] }) { }
}

export class GetProjectModelRelations implements Action {
  readonly type = ActionTypes.GetProjectModelRelations;
  constructor(public payload: { projectModelId: string }) { }
}

export class GetProjectModelRelationsSuccessful implements Action {
  readonly type = ActionTypes.GetProjectModelRelationsSuccessful;
  constructor(public payload: { projectModelRelations: ProjectModelRelation[] }) { }
}

export class GetProjectModelRelationsFailure implements Action {
  readonly type = ActionTypes.GetProjectModelRelationsFailure;
}

export class CreateProjectModelRelation implements Action {
  readonly type = ActionTypes.CreateProjectModelRelation;
  constructor(public payload: { sourceModelId: string; projectModelRelation: NewProjectModelRelation; relationedTypeId?: string; navigateAfterCreate?: boolean }) { }
}

export class CreateProjectModelRelationSuccessful implements Action {
  readonly type = ActionTypes.CreateProjectModelRelationSuccessful;
  constructor(public payload: { projectModelRelations: ProjectModelRelation[] }) { }
}

export class CreateProjectModelRelationFailure implements Action {
  readonly type = ActionTypes.CreateProjectModelRelationFailure;
}

export class UpdateProjectModelRelation implements Action {
  readonly type = ActionTypes.UpdateProjectModelRelation;
  constructor(public payload: { projectModelRelationId: string; projectModelRelation: ProjectModelRelationUpdateDto; sourceModelId: string }) { }
}

export class UpdateProjectModelRelationSuccessful implements Action {
  readonly type = ActionTypes.UpdateProjectModelRelationSuccessful;
  constructor(public payload: { projectModelRelationId: string; projectModelRelation: ProjectModelRelation }) { }
}

export class UpdateProjectModelRelationFailure implements Action {
  readonly type = ActionTypes.UpdateProjectModelRelationFailure;
}
export class DeleteProjectModelRelation implements Action {
  readonly type = ActionTypes.DeleteProjectModelRelation;
  constructor(public payload: { projectModelRelationId: string }) { }
}

export class DeleteProjectModelRelationSuccessful implements Action {
  readonly type = ActionTypes.DeleteProjectModelRelationSuccessful;
  constructor(public payload: { projectModelRelationId: string }) { }
}

export class DeleteProjectModelRelationFailure implements Action {
  readonly type = ActionTypes.DeleteProjectModelRelationFailure;
}

export class GenerateDataModelsWithRelations implements Action {
  readonly type = ActionTypes.GenerateDataModelsWithRelations;
  constructor(public payload: { relationData: OpenAiDataModelRelationResponseDto; projectId: string }) { }
}

export class GenerateDataModelsWithRelationsSuccessful implements Action {
  readonly type = ActionTypes.GenerateDataModelsWithRelationsSuccessful;
  constructor(public payload: { response: any }) { }
}

export class GenerateDataModelsWithRelationsFailure implements Action {
  readonly type = ActionTypes.GenerateDataModelsWithRelationsFailure;
  constructor(public payload: { error: any; key: string; timestamp: number }) { }
}

export class GenerateProjectModelRelationsWithAI implements Action {
  readonly type = ActionTypes.GenerateProjectModelRelationsWithAI;
  constructor(public payload: { aiPrompt: string; actionId?: string }) { }
}

export class GenerateProjectModelRelationsWithAISuccessful implements Action {
  readonly type = ActionTypes.GenerateProjectModelRelationsWithAISuccessful;
  constructor(public payload: { actionId?: string; generated: GenerateDataModelRelationsFromExampleDataDto }) { }
}

export class GenerateProjectModelRelationsWithAIFailure implements Action {
  readonly type = ActionTypes.GenerateProjectModelRelationsWithAIFailure;
  constructor(public payload: { error: any; key: string; timestamp: number }) { }
}

export class ErrorAction implements Action {
  readonly type = ActionTypes.ErrorAction;
  constructor(public payload: { error: any; key: string; timestamp: number }) { }
}

export type Actions =
  GetAllProjectModelRelations
  | GetAllProjectModelRelationsSuccessful
  | GetProjectModelRelations
  | GetProjectModelRelationsSuccessful
  | GetProjectModelRelationsFailure
  | CreateProjectModelRelation
  | CreateProjectModelRelationSuccessful
  | CreateProjectModelRelationFailure
  | UpdateProjectModelRelation
  | UpdateProjectModelRelationSuccessful
  | UpdateProjectModelRelationFailure
  | DeleteProjectModelRelation
  | DeleteProjectModelRelationSuccessful
  | DeleteProjectModelRelationFailure
  | GenerateDataModelsWithRelations
  | GenerateDataModelsWithRelationsSuccessful
  | GenerateDataModelsWithRelationsFailure
  | GenerateProjectModelRelationsWithAI
  | GenerateProjectModelRelationsWithAISuccessful
  | GenerateProjectModelRelationsWithAIFailure
  | ErrorAction;
